import { NotificationsActionTypes } from "./constants";

export interface NotificationActionType {
  type: NotificationsActionTypes;
  payload?: any;
}

// Get Notifications
export const getNotifications = (
  skip: number = 0,
  limit: number = 20
): NotificationActionType => ({
  type: NotificationsActionTypes.GET_NOTIFICATIONS,
  payload: { skip, limit },
});

export const getNotificationsSuccess = (
  actionType: string,
  data: any,
  skip: number = 0
): NotificationActionType => ({
  type: NotificationsActionTypes.GET_NOTIFICATIONS_SUCCESS,
  payload: { actionType, data, skip },
});

export const getNotificationsError = (
  actionType: string,
  error: string
): NotificationActionType => ({
  type: NotificationsActionTypes.GET_NOTIFICATIONS_ERROR,
  payload: { actionType, error },
});

// Get Unread Count
export const getUnreadCount = (): NotificationActionType => ({
  type: NotificationsActionTypes.GET_UNREAD_COUNT,
  payload: {},
});

export const getUnreadCountSuccess = (
  actionType: string,
  count: number
): NotificationActionType => ({
  type: NotificationsActionTypes.GET_UNREAD_COUNT_SUCCESS,
  payload: { actionType, count },
});

export const getUnreadCountError = (
  actionType: string,
  error: string
): NotificationActionType => ({
  type: NotificationsActionTypes.GET_UNREAD_COUNT_ERROR,
  payload: { actionType, error },
});

// Mark as Read
export const markAsRead = (id: string): NotificationActionType => ({
  type: NotificationsActionTypes.MARK_AS_READ,
  payload: { id },
});

export const markAsReadSuccess = (
  actionType: string,
  data: any
): NotificationActionType => ({
  type: NotificationsActionTypes.MARK_AS_READ_SUCCESS,
  payload: { actionType, data },
});

export const markAsReadError = (
  actionType: string,
  error: string
): NotificationActionType => ({
  type: NotificationsActionTypes.MARK_AS_READ_ERROR,
  payload: { actionType, error },
});

// Mark All as Read
export const markAllAsRead = (): NotificationActionType => ({
  type: NotificationsActionTypes.MARK_ALL_AS_READ,
  payload: {},
});

export const markAllAsReadSuccess = (
  actionType: string,
  data: any
): NotificationActionType => ({
  type: NotificationsActionTypes.MARK_ALL_AS_READ_SUCCESS,
  payload: { actionType, data },
});

export const markAllAsReadError = (
  actionType: string,
  error: string
): NotificationActionType => ({
  type: NotificationsActionTypes.MARK_ALL_AS_READ_ERROR,
  payload: { actionType, error },
});

// Real-time notification (Socket.IO)
export const addNotification = (notification: any): NotificationActionType => ({
  type: NotificationsActionTypes.ADD_NOTIFICATION,
  payload: { notification },
});

export const removeNotification = (id: string): NotificationActionType => ({
  type: NotificationsActionTypes.REMOVE_NOTIFICATION,
  payload: { id },
});

export const clearNotifications = (): NotificationActionType => ({
  type: NotificationsActionTypes.CLEAR_NOTIFICATIONS,
  payload: {},
});
